import React, { useEffect, useState } from "react";
import SearchIcon from "@material-ui/icons/Search";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { Grid, Tooltip } from "@material-ui/core";
import { Link } from 'react-router-dom';
import { DatePickerInput } from 'rc-datepicker';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import Moment from "moment";
import BiztranControls from "../biztran_controls/BiztranControls";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import ModalFrame from "../biztran_controls/Modal_Frame";
import UseFetchData from "../../hooks/UseFetchData";
import moment from "moment";

const todate = new Date();
// let fromDate = new Date().getFullYear() + "/04/01"
// const fromdate = new Date().setFullYear(new Date().getFullYear(), -10);
// const fromdate = new Date(new Date().setDate(new Date().getDate() - 300));
let fromDate = new Date("2024/04/01");
let Dfromdate = new Date("2024/04/01")

const SalesReportTally = () => {

    const [Status, setStatus] = useState('');
    const [Customer, setCustomer] = useState('');
    const [Industry, setIndustry] = useState('');
    const [Count, setCount] = useState('');
    const [SalesExecutiveID, setSalesExecutiveID] = useState('');
    // const [SalesExecutiveID, setSalesExecutiveID] = useState('');
    const [FromDate, setFromDate] = useState(fromDate);
    const [defaultfromDate, setdefaultfromDate] = useState(Dfromdate);
    const [ToDate, setToDate] = useState(todate.toISOString());
    const [ProductGroupIDcmb, setProductGroupIDcmb] = useState([]);
    const [defaultToDate, setdefaultToDate] = useState(todate);
    const [ComboSalesExecutive, setComboSalesExecutive] = useState([]);
    const [ProductIDcmb, setProductIDcmb] = useState([]);
    const [CountryIDcmb, setCountryIDcmb] = useState([]);
    const [StateIDcmb, setStateIDcmb] = useState([]);
    const [IndustryIDcmb, setIndustryIDcmb] = useState([]);
    const [ProductID, setProductID] = useState('');
    const [ProductGroupID, setProductGroupID] = useState('');
    const [CountryID, setCountryID] = useState('');
    const [IndustryID, setIndustryID] = useState('');
    const [AccountID, setAccountID] = useState('');
    const [AccountName, setAccountName] = useState('');
    const [AccName, setAccName] = useState('');
    const [StateID, setStateID] = useState('');
    const [responseAccount, fetchAccountData] = UseFetchData();
    const [AccountOptions, setAccountOptions] = useState([]);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [SearchMode, setSearchMode] = useState("SEARCH");

    const onFromClear = () => {
        setFromDate();
        setdefaultfromDate();
    }

    const onToClear = () => {
        setToDate();
        setdefaultToDate();
    }
    const AccountData = () => {
        var bodyFormData = new FormData();
        fetchAccountData("QuotationAnalysis/ComboData", bodyFormData);
    }

    // const exportToCSV = (data, fileName) => {
    //     // Define the fields you want to export
    //     const fields = [
    //       'Order_No', 'Order_Date', 'HandledBy', 'PONumber', 'PODate', 'SOContactName', 'Party_Name', 'Buyer_add1','Location','State','Country','Pincode','ShipAddress1', 'ModelCode', 'Billed_Qty', 'Units', 'Rate', 'Currency', 'Value_Amt', 'GST_Rate', 'DiscountPer', 'PFCharges', 'OtherCharges1', 'OtherCharges1Amt', 'OtherCharges2','OtherCharges2Amt', 'SODiscount','DeliveryDate', 'IncoTerms',  'ModeOfTransport',  'Description','HSN Code','PaymentTerms','GST_No','PortOfLoading','FinalDestination'
    //     ];
      
    //     const formatDate = (dateString) => {
    //         if (!dateString) return '';
    //         const date = new Date(dateString);
    //         const day = String(date.getDate()).padStart(2, '0');
    //         const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
    //         const year = date.getFullYear();
    //         return `${day}/${month}/${year}`;
    //       };
    //     // Generate the header row
    //     const header = fields.join(',') + '\n';
      
    //     // Generate CSV rows
    //     const rows = data.map((row) => {
    //         return fields.map((field) => {
    //           let value = row[field] || ''; // Handle empty or undefined values
        
    //           // Check if the field is a date field and format it
    //             if (field.includes('Date') && value) {
    //                 value = formatDate(value);  // Format the date to DD/MM/YYYY
    //             }
    //           // Check if the value contains any special characters
    //           if (typeof value === 'string') {
    //             // Escape double quotes by doubling them
    //             value = value.replace(/"/g, '""');
                
    //             // Wrap value in double quotes if it contains commas, new lines, or double quotes
    //             if (value.includes(',') || value.includes('\n') || value.includes('"')) {
    //               value = `"${value}"`;  // Wrap in double quotes
    //             }
    //           }
        
    //           return value;
    //         }).join(',');
    //       }).join('\n');
      
    //     // Combine header and rows
    //     const csvContent = header + rows;
      
    //     // Create a Blob from the CSV data
    //     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      
    //     // Create a link to download the CSV file
    //     const link = document.createElement('a');
    //     if (link.download !== undefined) { // Feature detection
    //       const url = URL.createObjectURL(blob);
    //       link.setAttribute('href', url);
    //       link.setAttribute('download', fileName);
    //       document.body.appendChild(link);
    //       link.click();
    //       document.body.removeChild(link);
    //     }
    //   };

    const exportToCSV = (data, fileName) => {
        // Ensure the filename has a .csv extension
        if (!fileName.endsWith('.csv')) {
            fileName += '.csv';
        }
    
        // Define the fields you want to export
        const fields = [
            'Order_No', 'Order_Date', 'HandledBy', 'PONumber', 'PODate', 'SOContactName', 'Party_Name', 
            'Buyer_add1', 'Location', 'State', 'Country', 'Pincode', 'ShipAddress1', 'ModelCode', 
            'Billed_Qty', 'Units', 'Rate', 'Currency', 'Value_Amt', 'GST_Rate', 'DiscountPer', 'PFCharges', 
            'OtherCharges1', 'OtherCharges1Amt', 'OtherCharges2', 'OtherCharges2Amt', 'SODiscount', 
            'DeliveryDate', 'IncoTerms', 'ModeOfTransport', 'Description', 'HSN Code', 'PaymentTerms', 
            'GST_No', 'PortOfLoading', 'FinalDestination'
        ];
    
        const formatDate = (dateString) => {
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        };
    
        // Generate the header row
        const header = fields.join(',') + '\n';
    
        // Generate CSV rows
        const rows = data.map((row) => {
            return fields.map((field) => {
                let value = row[field] || ''; // Handle empty or undefined values
    
                // Check if the field is a date field and format it
                if (field.includes('Date') && value) {
                    value = formatDate(value);  // Format the date to DD/MM/YYYY
                }
    
                // Escape double quotes by doubling them and wrap in double quotes if necessary
                if (typeof value === 'string') {
                    value = value.replace(/"/g, '""');
                    if (value.includes(',') || value.includes('\n') || value.includes('"')) {
                        value = `"${value}"`;  // Wrap in double quotes
                    }
                }
    
                return value;
            }).join(',');
        }).join('\n');
    
        // Combine header and rows
        const csvContent = header + rows;
    
        // Create a Blob from the CSV data with a UTF-8 BOM (Byte Order Mark)
        const csvWithBom = '\uFEFF' + csvContent; // Add BOM for UTF-8 encoding
        const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
    
        // Create a link to download the CSV file
        const link = document.createElement('a');
        if (link.download !== undefined) { // Feature detection
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
            // Revoke the object URL to free up memory
            URL.revokeObjectURL(url);
        }
    };
    

    useEffect(() => {
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse["Productcmb"] !== undefined) {
                setProductIDcmb(ComboDataResponse["Productcmb"]);
            }
            if (ComboDataResponse["cmbProductGroup"] !== undefined) {
                setProductGroupIDcmb(ComboDataResponse["cmbProductGroup"]);

            }
            if (ComboDataResponse["cmbCountry"] !== undefined) {
                setCountryIDcmb(ComboDataResponse["cmbCountry"]);

            }
            if (ComboDataResponse["cmbState1"] !== undefined) {
                setStateIDcmb(ComboDataResponse["cmbState1"]);

            }
            if (ComboDataResponse["cmbIndustry"] !== undefined) {
                setIndustryIDcmb(ComboDataResponse["cmbIndustry"]);

            }
            if (ComboDataResponse["SalesExecutive"] !== undefined) {
                setComboSalesExecutive(ComboDataResponse["SalesExecutive"]);

            }

            //   if (ComboDataResponse["Productcmb"] !== undefined) {
            //     setProductIDcmb(ComboDataResponse["Productcmb"]);
            //   }
            //   PopulateData(SearchMode);

        }
    }, [ComboDataResponse]);

    const GetComboData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("ProductID", "");
        // bodyFormData.append("ProductCat1ID", "");
        // bodyFormData.append("ProductCat2ID", "");
        // bodyFormData.append("ProductCat3ID", "");
        fetchComboData("QuotationAnalysis/ComboData", bodyFormData);
    };

    const handleExport = () => {
        exportToCSV(rows, 'PMCRMSalesReportTally.csv');
      };

    const onACCChange = (event, newValue) => {
        // debugger;
        setAccountName(newValue);
        setAccountID(newValue.id);
    }

    useEffect(() => {
        // debugger;
        if (responseAccount['cmbAccount'] !== undefined && responseAccount['cmbAccount'].length > 0) {
            setAccountOptions(responseAccount['cmbAccount']);
        }
    }, [responseAccount['cmbAccount']]);

    const PopulateData = () => {
        // debugger;
        var SalesTeamList = "";
        var AccoName = "",
            AcName = null;
        // debugger;
        var bodyFormData = new FormData();
        if (AccountName !== undefined) {
            AccoName = AccountName.AccountName;
        }
        if (AccName !== "") {
            AcName = AccName;
        }
        var bodyFormData = new FormData();
        bodyFormData.append("AccountName", AccountName.List);
        bodyFormData.append("IndustryID", IndustryID);
        bodyFormData.append("SalesExecutiveID", SalesExecutiveID);
        bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
        bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
        bodyFormData.append("Status", Status);
        // bodyFormData.append("SearchString", AccName);
        bodyFormData.append("StateID", StateID);
        bodyFormData.append("ProductGroupID", ProductGroupID);
        bodyFormData.append("ProductID", ProductID);
        bodyFormData.append("CountryID", CountryID);
        //bodyFormData.append("Description", Description);
        fetchData("SalesReportTally/SalesReport", bodyFormData);
    };

    useEffect(() => {
        const gridCols = [

            {
                field: "Order_No",
                headerName: "Sales Order No.",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,

            },
            {
                field: "Order_Date",
                headerName: "Sales Order Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                valueFormatter: params =>
                    moment(params?.value).format("DD/MM/YYYY"),
            },
            // {
            //     field: "GeneratedBy",
            //     headerName: "Generated By",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 180,
            // },
            {
                field: "HandledBy",
                headerName: "Handled By",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "PONumber",
                headerName: "PO Ref.",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "PODate",
                headerName: "PO Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
                valueFormatter: params => {
                    const value = params?.value;
                    // Check if the value is not null, undefined, or an empty string
                    return value ? moment(value).format("DD/MM/YYYY") : "";
                },
            },
            {
                field: "SOContactName",
                headerName: "SO Contact",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 170,
            },
            {
                field: "Party_Name",
                headerName: "Account Name",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Buyer_add1",
                headerName: "Billing Address",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Location",
                headerName: "City",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "State",
                headerName: "State",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Country",
                headerName: "Country",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "Pincode",
                headerName: "Pincode",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "ShipAddress1",
                headerName: "Shipping Address",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 250,
            },
            {
                field: "ModelCode",
                headerName: "Model Code",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,
                // renderCell: (params) => (
                //     <Tooltip title={params.row.Description} >
                //         <span className="table-cell-trucate">{params.row.Description}</span>
                //     </Tooltip>
                // ),
            },
            // {
            //     field: "ProductName",
            //     headerName: "Product Name",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 210,
            //     // renderCell: (params) => (
            //     //     <Tooltip title={params.row.Description} >
            //     //         <span className="table-cell-trucate">{params.row.Description}</span>
            //     //     </Tooltip>
            //     // ),
            // },
            {
                field: "Billed_Qty",
                headerName: "Qty",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
                // renderCell: (params) => (
                //     <Tooltip title={params.row.AccountName} >
                //         <span className="table-cell-trucate">{params.row.AccountName}</span>
                //     </Tooltip>
                // ),
            },
            {
                field: "Units",
                headerName: "Unit",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "Rate",
                headerName: "Rate",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "Currency",
                headerName: "Currency",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            // {
            //     field: "ConvFactor",
            //     headerName: "Curr.Conversion",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 180,
            // },
            {
                field: "Value_Amt",
                headerName: "Amount",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 150,
            },
            {
                field: "GST_Rate",
                headerName: "GST Rate",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "DiscountPer",
                headerName: "Discount % ",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "PFCharges",
                headerName: "Packing & Forwarding",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 220,
            },
            
            {
                field: "OtherCharges1",
                headerName: "Other1",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "OtherCharges1Amt",
                headerName: "Other1_Value",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "OtherCharges2",
                headerName: "Other2",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            {
                field: "OtherCharges2Amt",
                headerName: "Other2_Value",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "SODiscount",
                headerName: "Discount",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 160,
            },
            
            {
                field: "DeliveryDate",
                headerName: "Delivery Date",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
                valueFormatter: params => {
                    const value = params?.value;
                    // Check if the value is not null, undefined, or an empty string
                    return value ? moment(value).format("DD/MM/YYYY") : "";
                },
            },
            // {
            //     field: "IgstAmount",
            //     headerName: "IgstAmount",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 180,
            // },
            // {
            //     field: "Warranty",
            //     headerName: "Warranty",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 180,
            // },
            {
                field: "IncoTerms",
                headerName: "INCO Terms",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            // {
            //     field: "DeliverySchedule",
            //     headerName: "Delivery Terms",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            // },
            {
                field: "ModeOfTransport",
                headerName: "Ship Mode",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            // {
            //     field: "CreatedBy",
            //     headerName: "Created By",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            // },
            // {
            //     field: "CreatedOn",
            //     headerName: "Created Date",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            //     valueFormatter: params => {
            //         const value = params?.value;
            //         // Check if the value is not null, undefined, or an empty string
            //         return value ? moment(value).format("DD/MM/YYYY") : "";
            //     },
            // },
            // {
            //     field: "ModifiedBy",
            //     headerName: "Modified By",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 200,
            // },
            // {
            //     field: "ModifiedDate",
            //     headerName: "Modified Date",
            //     headerClassName: "super-app-theme--header",
            //     headerAlign: "center",
            //     width: 190,
            //     valueFormatter: params =>
            //         moment(params?.value).format("DD/MM/YYYY"),
            // },
            {
                field: "Description",
                headerName: "ItemName",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 300,
            },
            {
                field: "HSN Code",
                headerName: "HSN Code",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 180,
            },
            {
                field: "PaymentTerms",
                headerName: "Payment Terms",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "GST_No",
                headerName: "GST Number",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            {
                field: "PortOfLoading",
                headerName: "Port of Loading",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 210,
            },
            {
                field: "FinalDestination",
                headerName: "Fnal Destination",
                headerClassName: "super-app-theme--header",
                headerAlign: "center",
                width: 200,
            },
            
        ];
        setColumns(gridCols);
        // debugger;
        setRows(response);
        setCount(response.length);
    }, [response]);

    useEffect(() => {
        GetComboData();
        PopulateData();
        AccountData();

    }, []);

    function CustomToolbar() {
        return (
            <GridToolbarContainer style={{ marginLeft: '93%', justifyContent: 'flex-end' }}>
                <GridToolbarExport csvOptions={{
                    fields: ['Order_No', 'Order_Date', 'HandledBy', 'PONumber', 'PODate', 'SOContact', 'Party_Name', 'Buyer_add1', 'ShipAddress1', 'ModelCode', 'Billed_Qty', 'Units', 'Rate', 'Currency', 'Value_Amt', 'GST_Rate', 'DiscountPer', 'PFCharges', 'Discountper', 'OtherCharges1', 'DeliveryDate', 'Delivery', 'DeliverySchedule', 'ModeOfTransport',  'ItemName','HSN Code','PaymentTerms','GST_No']
                }} />
            </GridToolbarContainer>
        );
    }

    return <div >
        <Grid container direction="row" >
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <div style={{ width: "198px", marginLeft: 6 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setFromDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onFromClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultfromDate}
                    />
                </div>
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <div style={{ width: "198px", marginLeft: 7 }}>
                    <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
                    <DatePickerInput
                        onChange={(jsDate, dateString) => setToDate(dateString)}
                        locale="en"
                        displayFormat="DD/MMM/YYYY"
                        className='my-react-component'
                        onClear={() => { onToClear(); }}
                        showOnInputClick
                        maxDate={new Date()}
                        returnFormat="YYYY/MM/DD"
                        defaultValue={defaultToDate}
                    />
                </div>
            </Grid>
            <label style={{ fontWeight: 'bold', width: 30, marginTop: 30 }}>{Count}</label>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Button
                    text="Populate"
                    style={{ marginRight: 50, marginTop: 20, marginLeft: 10 }}
                    startIcon={<SearchIcon />}
                    onClick={() => {
                        PopulateData();
                    }}
                />
            </Grid>
            {/* <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }} >
                <BiztranControls.Autocomplete
                    label="Customer"
                    options={AccountOptions}
                    style={{ marginLeft: 7, marginTop: -7, width: "198px" }}
                    onChange={onACCChange}
                    value={AccName}>
                </BiztranControls.Autocomplete>
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }} >
                <BiztranControls.Select
                    label="Industry"
                    id="Industry"
                    options={IndustryIDcmb}
                    onChange={(e) => setIndustryID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }} >
                <BiztranControls.Select
                    label="ProductName"
                    id="Product"
                    options={ProductIDcmb}
                    onChange={(e) => setProductID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} style={{ marginTop: 14 }}>
                <BiztranControls.Select
                    label="ProductGroup"
                    id="ProductGroup"
                    options={ProductGroupIDcmb}
                    onChange={(e) => setProductGroupID(e.target.value)}
                />
            </Grid> */}
        </Grid>
        <Grid container direction="row" style={{ marginTop: 7 }} >
            {/* <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Input
                    label="Status"
                    id="Status"
                    onChange={(e) => setStatus(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="Country"
                    id="Country"
                    options={CountryIDcmb}
                    onChange={(e) => setCountryID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="State"
                    id="State"
                    options={StateIDcmb}
                    onChange={(e) => setStateID(e.target.value)}
                />
            </Grid>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Select
                    label="Sales Executive"
                    id="SalesExecutiveID"
                    options={ComboSalesExecutive}
                    onChange={(e) => setSalesExecutiveID(e.target.value)}
                />
            </Grid> */}
            {/* <label style={{ fontWeight: 'bold', width: 30, marginTop: 15, marginLeft: -10 }}>{Count}</label>
            <Grid xs={12} sm={3} md={3} lg={2} xl={2} >
                <BiztranControls.Button
                    text="Populate"
                    style={{ marginRight: 50 }}
                    startIcon={<SearchIcon />}
                    onClick={() => {
                        PopulateData();
                    }}
                />
            </Grid> */}
        </Grid>
        <button onClick={handleExport}>Export to CSV</button>
        <BiztranControls.DataGrid
            headerHeight={34}
            rowHeight={25}
            rows={rows}
            columns={columns}
            checkboxSelection={false}
            // autoHeight={true}
            //Height="2610px"
            Height="400px"
            Width="100%"
            //components={{ Toolbar: CustomToolbar, }}
        />

    </div>
};

export default SalesReportTally;